import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_192: DocMigration = {
  maxSchemaVersion: "0.0.192",
  description: "Rename Param.valueConfig to paramValues",
  apply(json: any) {
    for (const paramId in json.params) {
      if (json.params[paramId].valueConfig) {
        const param = json.params[paramId];

        param.paramValues = param.valueConfig;

        delete param.valueConfig;
      }
    }

    return json;
  },
};

export default migration_0_0_192;
